module.exports = __webpack_public_path__ + "media/promo/panasonic/images/video-bfbb53f72333e268a03d39b0885393f6.jpg";